import React from 'react';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { onEnterAction } from '../utils/a11y';

interface Props {
  title: string;
  completed?: boolean;
  disabled?: boolean;
  onClick(): void;
}

export const ChecklistItem = ({ title, completed = false, disabled = false, onClick }: Props): JSX.Element => {
  const statusColor = disabled ? 'bg-gray-400' : completed ? 'bg-sapphire' : 'bg-transparent border-2 border-gray-400';
  const containerStyles = `flex items-center p-4 border-b ${
    disabled ? 'bg-gray-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer hover:bg-gray-100'
  }`;

  return (
      <div tabIndex={0} className={`shadow-md ${containerStyles}`} onKeyDown={(e): void => onEnterAction(e, onClick)} onClick={onClick} role='button' aria-label={title}>
        <div className={`flex items-center w-5 h-5 rounded-full items-center justify-center text-white ${statusColor}`}>
          {completed && (
            <FontAwesomeIcon icon={faCheck} />
          )}
        </div>

        <div className={`flex-grow pl-2 text-medium ${disabled ? 'text-gray-400' : 'text-black'}`}>
          {title}
        </div>
        {!disabled && (
          <div className='flex-shrink-0 text-gray-400 pl-2'>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        )}
      </div>
  );
};
